import * as React from 'react';
import { Spinner, Intent, Button, H4, Tooltip, Icon, H2, H3 } from '@blueprintjs/core';
import { UserState } from 'app/reducers/state';
import { executeQueryPostAuth, executeQueryGetAuth, API_CHARTBACK } from 'app/utils/api';
import { KryPlayDetails2 } from 'app/components/KryPlayDetails2';
import { each } from 'lodash';
import { CoachingAudio } from 'app/components/CoachingAudio';
import * as superagent from 'superagent';

import Highcharts from 'highcharts';
import ReactHighcharts from 'highcharts-react-official';
import highchartsMore from 'highcharts/highcharts-more';
import hcXrange from 'highcharts/modules/xrange';
import { KryPlayDetails } from 'app/components/KryPlayDetails';
import TextAreaV2 from 'app/components/TextAreaV2';
import CoachFeedback from 'app/components/CoachFeedback';

highchartsMore(Highcharts);
(hcXrange)(Highcharts)

const GOOD_CUTOFF = 0.50;

interface Props {
    objectiveData?: any;
    gameID: string;
    user: UserState;
    needsJournal: boolean;
    promptData: any;
    menuConfig: any;
    progressSoFar: any;
    savedPreJournal: string;
    initialStylesV1?: any;
    globalConfigs: any;
    onResume: () => void;
    onSaveJournal: (preFeedback: string, redo: boolean) => void;
    onSaveJournalUsePrefeedback: (preFeedback: string, redo: boolean) => void;
};

interface State {
    loadingObjectiveData: boolean;
    objectiveData: any;
    writtenJouranl: string;
    savingJournal: boolean;
    coachingAudio: string | string[];
    showObjectives: boolean;
    loadingCharts: boolean;
    chartData: any;
    commitmentScore: number;
    businessScore: number;
    sub1Score: number;
    sub2Score: number;
    sub3Score: number;
    showScore: boolean;
    promptData: any;
    promptInput: any;
    aiCoachLoading: boolean;
    aiCoachResults: any;
    hasEvaluated: boolean;
}

export class ResultsScreen extends React.Component<Props, State> {

    state: State = {
        loadingObjectiveData: true,
        objectiveData: {},
        writtenJouranl: '',
        savingJournal: false,
        coachingAudio: '',
        showObjectives: true,
        loadingCharts: true,
        chartData: [],
        commitmentScore: 0.0,
        businessScore: 0.0,
        sub1Score: 0.0,
        sub2Score: 0.0,
        sub3Score: 0.0,
        promptData: {},
        showScore: false,
        promptInput: {},
        aiCoachLoading: false,
        aiCoachResults: undefined,
        hasEvaluated: false
    }

    getPrompt = () => {
        const {
            menuConfig
        } = this.props;

        return menuConfig.postJournalTitle;
    }

    getShowClassicScores = () => {
        // JTB, we're backing this out for now.  To get a stable build out otherwise
        return false;

        const {
            menuConfig
        } = this.props;

        return menuConfig.showClassicScoring === true;
    }

    getStyleTitle = () => {
        const {
            menuConfig
        } = this.props;

        return menuConfig.title;
    }

    loadSubData = () => {
        superagent.
            get(API_CHARTBACK() + '?userID=' + this.props.user.id + '&gameID=' + this.props.gameID).
            end((error: any, response: any) => {
                try {
                    const resp = JSON.parse(response.text);

                    const sub1Score = resp.er;
                    const sub2Score = resp.ci;
                    const sub3Score = resp.fi;
                    const commitmentScore = resp.commitmentScore;
                    const businessScore = (sub1Score + sub2Score + sub3Score) / 3.0;

                    this.setState({
                        sub1Score,
                        sub2Score,
                        sub3Score,
                        commitmentScore,
                        businessScore
                    });
                }
                catch (e) {

                }
            });
    }

    componentDidMount() {

        const promptData = this.props.promptData;

        let newPromptInput = {};

        if (this.props.user.classicMode === 2) {
            if (promptData && promptData.classic) {
                for (let i = 0; i < promptData.classic.post.length; i++) {
                    const __prompt = promptData.classic.post[i];
                    newPromptInput[__prompt] = '';
                }
            }
        }
        else {
            if (promptData && promptData.lab) {
                for (let i = 0; i < promptData.lab.post.length; i++) {
                    const __prompt = promptData.lab.post[i];
                    newPromptInput[__prompt] = '';
                }
            }
        }
        this.setState({
            promptData,
            promptInput: newPromptInput
        });

        if (this.props.user.classicMode === 2) {
            superagent.
                get(API_CHARTBACK() + '?gameID=' + this.props.gameID).
                end((error: any, response: any) => {
                    if (error || !response || !response.text) {
                        console.error('Error loading chart data:', error);
                        this.setState({
                            loadingCharts: false,
                            chartData: []
                        });
                        return;
                    }

                    try {
                        this.setState({
                            loadingCharts: false,
                            chartData: JSON.parse(response.text)
                        });
                    } catch (parseError) {
                        console.error('Error parsing chart data response:', parseError);
                        this.setState({
                            loadingCharts: false,
                            chartData: []
                        });
                    }
                });
        }
        else {
            this.setState({
                loadingObjectiveData: true
            });

            executeQueryPostAuth("data/results/" + this.props.gameID, {}, this.props.user, (postResponse) => {
                executeQueryGetAuth("data/results/" + this.props.gameID, {}, this.props.user, (objectiveResponse) => {
                    const response = JSON.parse(objectiveResponse.text);

                    this.setState({
                        loadingObjectiveData: false,
                        objectiveData: response
                    }, () => {
                        this.processCoachingTriggers(response);

                        this.loadSubData();

                        const {
                            menuConfig
                        } = this.props;

                        if (menuConfig.blockObjectives === true) {
                            this.setState({
                                showObjectives: false
                            });
                        }
                    });
                });
            });
        }
    }

    getAudioConfig = () => {
        const {
            menuConfig
        } = this.props;
        /*
            Possible audio entries
            good_goal: undefined,
            bad_goal: undefined,
            neutral_goal: undefined,
            good_process: undefined,
            bad_process: undefined,
            neutral_process: undefined
        */

        if (menuConfig === undefined) return {};

        if (menuConfig['outcomeaudio'] === undefined) return {};

        return menuConfig['outcomeaudio'];
    }

    processCoachingTriggers = (objectiveData) => {
        const audioConfig = this.getAudioConfig();

        let stats = {
            outcome_total: 0,
            outcome_positive: 0,
            outcome_result: 0.0,
            process_total: 0,
            process_positive: 0,
            process_result: 0.0,
        }

        each(objectiveData.objectives, objective => {
            const categoryname = objective.category;
            const isSuccessfull = objective.result === "True" || objective.result === "true";

            if (categoryname === undefined) return;

            if (categoryname.includes("Outcome")) {
                stats.outcome_total += 1;

                if (isSuccessfull) {
                    stats.outcome_positive += 1;
                }
            }
            else {
                stats.process_total += 1;

                if (isSuccessfull) {
                    stats.process_positive += 1;
                }
            }
        });

        // Calculate our results
        stats.outcome_result = stats.outcome_positive / stats.outcome_total;
        stats.process_result = stats.process_positive / stats.process_total;

        const isOutcomeGood = (stats.outcome_result >= GOOD_CUTOFF);
        const isProcessGood = (stats.process_result >= GOOD_CUTOFF);

        // Determine overall performance - consider both process and outcome
        // If both are good, or if outcome is excellent (>=80%), consider it overall good
        const isOverallGood = (isProcessGood && isOutcomeGood) || (stats.outcome_result >= 0.8);
        
        const audioLocationInMap = isOverallGood ? 'good_process' : 'bad_process';
        const audioLocationInMapOutcome = isOutcomeGood ? 'good_goal' : 'bad_goal';

        let audioLocations: string[] = [];

        if (audioConfig[audioLocationInMapOutcome] !== undefined) {
            audioLocations.push(audioConfig[audioLocationInMapOutcome]);
        }

        if (audioConfig[audioLocationInMap] !== undefined) {
            audioLocations.push(audioConfig[audioLocationInMap]);
        }

        // Now add all of our "additionalAudio" pieces
        each(audioConfig['additionalAudio'], optionalAudio => {
            audioLocations.push(
                optionalAudio
            );
        });

        if (audioLocations.length > 0) {
            this.setState({
                coachingAudio: audioLocations
            });
        }
    }

    getCurrentRound = () => {
        const {
            objectiveData
        } = this.state;

        return parseInt(objectiveData['total-rounds']);
    }

    getJournalWarning = () => {
        const {
            writtenJouranl,
            hasEvaluated
        } = this.state;

        const wordCount = writtenJouranl.split(' ').length;

        if (wordCount > 10) return undefined;

        if (this.props.initialStylesV1 !== true) {
            if (hasEvaluated === false) {
                return 'Please evaluate your reflection before saving.';
            }
        }

        return 'You might want to reflect a little more.';
    }

    renderJournal = () => {
        const {
            savingJournal
        } = this.state;

        if (savingJournal) {
            return <span>
                <Spinner />
            </span>
        }

        let prompts = [];

        if (this.props.user.classicMode === 2) {
            if (this.state.promptData && this.state.promptData.classic) {
                for (let i = 0; i < this.state.promptData.classic.post.length; i++) {
                    const __prompt = this.state.promptData.classic.post[i];
                    const value = this.state.promptInput[__prompt];

                    prompts.push(
                        <div style={{ marginBottom: '10px' }}>
                            <H4 key={i}>{__prompt}</H4>
                            <TextAreaV2 value={value} onChange={(event) => {
                                this.setState({
                                    promptInput: Object.assign(this.state.promptInput, { [__prompt]: event.target.value })
                                });
                            }} className={"journalTextArea"} rows={5} style={{ width: '100%', height: '90px' }}></TextAreaV2>
                        </div>
                    );
                }
            }
        }
        else {
            if (this.state.promptData && this.state.promptData.lab) {
                for (let i = 0; i < this.state.promptData.lab.post.length; i++) {
                    const __prompt = this.state.promptData.lab.post[i];
                    const value = this.state.promptInput[__prompt];

                    prompts.push(
                        <div style={{ marginBottom: '10px' }}>
                            <H4 key={i}>{__prompt}</H4>
                            <TextAreaV2 value={value} onChange={(event) => {
                                this.setState({
                                    promptInput: Object.assign(this.state.promptInput, { [__prompt]: event.target.value })
                                });
                            }} className={"journalTextArea"} rows={5} style={{ width: '100%', height: '90px' }}></TextAreaV2>
                        </div>
                    );
                }
            }
        }

        return <span style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
            <span style={{ width: '600px' }}>
                {prompts}
            </span>
            {/* <span style={{ alignContent: 'flex-end' }}>
                {this.props.initialStylesV1 === true ? undefined : <Button style={{ width: '400px', marginBottom: '10px', height: '45px' }} intent={Intent.PRIMARY} disabled={this.state.aiCoachLoading} onClick={() => {
                    this.executeAI(this.calculate_journal_as_string());
                }}>Evaluate My Reflection</Button>}
            </span> */}
            <span>
                {this.state.aiCoachLoading ? <Spinner /> : <span />}
                {this.state.aiCoachResults ? <CoachFeedback content={<span>
                    <h3>{this.state.aiCoachResults.question}</h3>
                    <p>
                        <h4>Strengths</h4>
                        {this.state.aiCoachResults.strengths.map((prompt, index) => (
                            <React.Fragment key={index}>
                                <span style={{ fontSize: '1.1rem' }}>{"- " + prompt}</span>
                                <br />
                            </React.Fragment>
                        ))}
                        <hr />
                        <h4>Weaknesses</h4>
                        {this.state.aiCoachResults.weaknesses.map((prompt, index) => (
                            <React.Fragment key={index}>
                                <span style={{ fontSize: '1.1rem' }}>{"- " + prompt}</span>
                                <br />
                            </React.Fragment>
                        ))}
                    </p>
                </span>} /> : <span />}
            </span>
            {/* <H4>{this.getPrompt()}</H4>
            <TextAreaV2 onChange={(event) => {
                this.setState({
                    writtenJouranl: event.target.value
                });
            }} className={"journalTextArea"} rows={5} style={{ width: '100%', height: '90px' }}></TextAreaV2> */}
        </span>
    }

    calculate_journal_as_string = () => {
        let lines = [];

        const {
            promptInput
        } = this.state;

        const keys = promptInput ? Object.keys(promptInput) : [];

        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const value = promptInput[key];

            if (value !== undefined && value !== null && value.length > 0) {
                lines.push(`${value}`);
            }
        }

        return lines.join('\n');
    }

    handleReplayButtonPress = () => {
        const {
            onResume,
            needsJournal,
            onSaveJournal
        } = this.props;

        if (needsJournal === false) {
            onResume();
            return;
        }

        console.log("final check", this.calculate_journal_as_string());

        onSaveJournal(this.calculate_journal_as_string(), true);
    }

    handleResumeButtonPress = () => {
        if (this.props.initialStylesV1 === true) {
            this.executeAI(this.calculate_journal_as_string(), () => {
                const {
                    onResume,
                    needsJournal,
                    onSaveJournal
                } = this.props;

                if (needsJournal === false) {
                    onResume();
                    return;
                }

                onSaveJournal(this.calculate_journal_as_string(), false);
            });
        }
        else {
            const {
                onResume,
                needsJournal,
                onSaveJournal
            } = this.props;

            if (needsJournal === false) {
                onResume();
                return;
            }

            onSaveJournal(this.calculate_journal_as_string(), false);
        }
    }

    renderChevron = (active: boolean) => {
        if (active === false) {
            return <span style={{
                float: 'left',
                display: 'block',
                height: '10px',
                width: '48px'
            }}>
            </span>
        }

        return <span>
            <Icon iconSize={32} style={{ marginRight: '8px', marginLeft: '8px', marginTop: '10px', float: 'left' }} icon='chevron-right' />
        </span>
    }

    renderScoreControlButton = () => {
        const {
            showScore
        } = this.state;

        return <span style={{ display: 'block' }}>
            {this.renderChevron((showScore === true))}
            <Button onClick={() => {
                this.setState({ showScore: true, showObjectives: false });
            }} large style={{ display: 'block', width: '350px', marginTop: '10px', height: '50px', marginLeft: '20px' }} intent={Intent.PRIMARY}>See your score</Button>
        </span>
    }

    renderReadYourOriginalPlanButton = () => {
        const {
            showObjectives,
            showScore
        } = this.state;

        return <span style={{ display: 'block' }}>
            {this.renderChevron((showObjectives === false && showScore === false))}
            <Button onClick={() => {
                this.setState({ showObjectives: false, showScore: false });
            }} large style={{ display: 'block', width: '350px', marginTop: '10px', height: '50px', marginLeft: '20px' }} intent={Intent.PRIMARY}>Read your Original Plan</Button>
        </span>
    }

    renderReflectOnWhatHappenedButton = () => {
        const {
            showObjectives
        } = this.state;

        return <span style={{ display: 'block' }}>
            {this.renderChevron(showObjectives)}
            <Button onClick={() => {
                this.setState({ showObjectives: true, showScore: false });
            }} large style={{ display: 'block', width: '350px', marginTop: '10px', height: '50px', marginLeft: '20px' }} intent={Intent.PRIMARY}>Reflect on What Happened</Button>
        </span>
    }
    calculate_ai_button_tooltip = () => {
        if (this.calculate_is_ai_button_disabled() === true) {
            return "Please evaluate your reflection before using AI Coach.";
        }

        return "";
    }

    calculate_is_ai_button_disabled = () => {
        const writtenSoFar = this.calculate_journal_as_string();

        if (writtenSoFar.length < 10) {
            return true;
        }

        return false;
    }

    calculate_is_changes_not_ready = () => {
        const {
            promptInput,
            hasEvaluated
        } = this.state;

        if (this.props.initialStylesV1 !== true) {
            if (hasEvaluated === false) return true;
        }

        if (promptInput === undefined) return true;

        const keys = Object.keys(promptInput);

        if (keys.length === 0) return true;

        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const value = promptInput[key];

            if (value.length <= 0) {
                return true;
            }
        }

        return false;
    }

    renderAIButton = () => {
        return <span style={{ display: 'block' }}>
            {this.renderChevron(false)}
            <Tooltip content={this.calculate_ai_button_tooltip()}>
                <Button onClick={() => {
                    this.executeAI(this.calculate_journal_as_string());
                }} disabled={this.calculate_is_ai_button_disabled()} large style={{ display: 'block', width: '350px', height: '50px', marginLeft: '49px' }} intent={Intent.PRIMARY}>Evaluate My Reflection</Button>
            </Tooltip>
        </span>
    }

    renderResumeButton = () => {
        const {
            needsJournal,
            menuConfig
        } = this.props;

        const RESULTS_SCREEN_BUTTON_STYLE = { display: 'block', width: '350px', marginTop: '10px', height: '60px', marginLeft: '50px' };

        if (needsJournal === false) {
            return <Button onClick={this.handleResumeButtonPress} disabled={this.calculate_is_changes_not_ready()} style={RESULTS_SCREEN_BUTTON_STYLE} large intent={Intent.SUCCESS}>Save Play</Button>
        }

        const journalWarning = this.getJournalWarning();

        const redoButton = (menuConfig.blockRedo === true) ? undefined : <Tooltip content={journalWarning}>
            <Button onClick={this.handleReplayButtonPress} style={RESULTS_SCREEN_BUTTON_STYLE} disabled={this.calculate_is_changes_not_ready()} large intent={Intent.SUCCESS}>Save and Replay</Button>
        </Tooltip>;

        return <span>
            {redoButton}
            <Tooltip content={journalWarning}>
                <Button onClick={this.handleResumeButtonPress} style={RESULTS_SCREEN_BUTTON_STYLE} disabled={this.calculate_is_changes_not_ready()} large intent={Intent.SUCCESS}>Save Play</Button>
            </Tooltip>
        </span>
    }

    renderAudio = () => {
        const {
            coachingAudio,
            loadingObjectiveData
        } = this.state;

        if (loadingObjectiveData) {
            return <span></span>
        }

        if (coachingAudio === undefined || coachingAudio === '') {
            return <span></span>
        }

        return <CoachingAudio
            audioSource={coachingAudio}
            donePlaying={() => {

            }}
        />
    }

    renderScoreDisplay = () => {
        const {
            commitmentScore,
            businessScore,
            sub1Score,
            sub2Score,
            sub3Score,
        } = this.state;

        if (this.props.initialStylesV1 === true) {

        }

        const finalScore = (commitmentScore + businessScore) / 2.0;

        const scoreLabelStyle = { fontSize: '40px' }

        const finalScoreTooltipContent = `( ${Math.round(businessScore)} + ${Math.round(commitmentScore)} ) A combination of your Business Score and Commitment Score gives you your final score`;
        const businessScoreTooltipContent = `( ${Math.round(sub1Score)} + ${Math.round(sub2Score)} + ${Math.round(sub3Score)} ) A combination all the impact factors gives you your Business Score`;
        const fiScoreTooltipContent = "The Financial Impact of your outcome";
        const ciScoreTooltipContent = "The Customer Impact of your outcome";
        const erScoreTooltipContent = "The Employee Retention Impact of your outcome";
        const commitmentScoreTooltipContent = "How commited was each member of the team.  Try getting the other members of the meeting to talk more.";

        const finalScoreContent = <Tooltip content={finalScoreTooltipContent}>{Math.round(finalScore)}</Tooltip>
        const businessScoreContent = <Tooltip content={businessScoreTooltipContent}>{Math.round(businessScore)}</Tooltip>
        const fiScoreContent = <Tooltip content={fiScoreTooltipContent}>{Math.round(sub1Score)}</Tooltip>
        const ciScoreContent = <Tooltip content={ciScoreTooltipContent}>{Math.round(sub2Score)}</Tooltip>
        const erScoreContent = <Tooltip content={erScoreTooltipContent}>{Math.round(sub3Score)}</Tooltip>
        const commitmentScoreContent = <Tooltip content={commitmentScoreTooltipContent}>{Math.round(commitmentScore)}</Tooltip>

        return <span style={{ flexGrow: 1, flexBasis: 0 }}>
            <span style={{ flexShrink: 1, transition: 'all 2s' }}>
                <span style={{ position: 'relative' }}>
                    <table className="classicScoreTable">
                        <tr><td><H2 style={{ fontSize: '60px' }}>Your Score </H2> </td><td style={scoreLabelStyle}>{finalScoreContent}</td></tr>
                        <tr><td><H3>Business Score </H3> </td><td style={scoreLabelStyle}>{businessScoreContent}</td></tr>
                        <tr><td><H4>Financial Impact </H4> </td><td style={scoreLabelStyle}>{fiScoreContent}</td></tr>
                        <tr><td><H4>Customer Impact </H4> </td><td style={scoreLabelStyle}>{ciScoreContent}</td></tr>
                        <tr><td><H4>Employee Retention </H4> </td><td style={scoreLabelStyle}>{erScoreContent}</td></tr>
                        <tr><td><H3>Commitment Score </H3> </td><td style={scoreLabelStyle}>{commitmentScoreContent}</td></tr>
                    </table>
                </span>
            </span>
        </span>
    }

    renderPlayDetails = () => {
        const {
            menuConfig,
            globalConfigs
        } = this.props;

        const {
            objectiveData
        } = this.state;

        if (menuConfig.blockObjectives === true) {
            return <span></span>
        }

        //@ts-ignore
        if (menuConfig.hybridJournalWriterEnabled === true) {
            return <KryPlayDetails2
                user={this.props.user}
                selectedGame={objectiveData}
                title={this.getStyleTitle()}
                canEditJournal={false}
                inSimulator={true}
                updateJournalDataInlineAndContinue={(stage: string, payload: string, gameID: string) => {
                    // ignore this, we aren't letting them edit in this mode

                    // Let's retrofit the "payload" variable for this to our new "save plan and play again"
                    this.props.onSaveJournalUsePrefeedback(payload, false);
                }}
                updateJournalDataInline={(stage: string, payload: string, gameID: string) => {
                    // ignore this, we aren't letting them edit in this mode
                    this.props.onSaveJournalUsePrefeedback(payload, true);
                }}
            />
        }
        else {
            if (this.props.initialStylesV1 === true) {
                return <div></div>
            }
            else {
                return <KryPlayDetails
                    user={this.props.user}
                    selectedGame={objectiveData}
                    canEditJournal={false}
                    progressSoFar={this.props.progressSoFar}
                    globalConfigs={globalConfigs}
                    title={this.getStyleTitle()}
                    originalJournalEntry={this.props.savedPreJournal}
                    inSimulator={true}
                    updateJournalDataInlineAndContinue={(stage: string, payload: string, gameID: string) => {
                        // ignore this, we aren't letting them edit in this mode

                        // Let's retrofit the "payload" variable for this to our new "save plan and play again"
                        this.props.onSaveJournalUsePrefeedback(payload, false);
                    }}
                    updateJournalDataInline={(stage: string, payload: string, gameID: string) => {
                        // ignore this, we aren't letting them edit in this mode

                        // Let's retrofit the "payload" variable for this to our new "save plan and play again"
                        this.props.onSaveJournalUsePrefeedback(payload, true);
                    }}
                />
            }
        }
    }

    renderDisplay = () => {
        const {
            showObjectives
        } = this.state;

        const {
            savedPreJournal
        } = this.props;

        if (showObjectives === true) {
            return <span style={{ flexGrow: 1, flexBasis: 0, width: '100%' }}>
                {this.renderPlayDetails()}
            </span>
        }

        // if (showScore === true) {
        //     return <span style={{flexGrow: 1, flexBasis: 0}}>
        //         {this.renderScoreDisplay()}
        //     </span>
        // }

        // if (showObjectives === true) {
        //     return <span style={{flexGrow: 1, flexBasis: 0, width: '100%'}}>
        //         {this.renderPlayDetails()}
        //     </span>
        // }

        // Show the user what they entered as there plan
        return <span style={{ flexGrow: 1, flexBasis: 0 }}>
            <span style={{ flexShrink: 1, transition: 'all 2s' }}>
                <span style={{ position: 'relative', top: '50px' }}>
                    <H4>What you entered as your plan for this play</H4>
                    <TextAreaV2 defaultValue={savedPreJournal} value={savedPreJournal} readOnly={true} className={"journalTextArea"} rows={5} style={{ width: '100%', height: '90px' }}></TextAreaV2>
                </span>
            </span>
        </span>
    }

    executeAI = (journal: string, cb?: any) => {
        this.setState({
            aiCoachLoading: true
        });

        let gameID = this.props.gameID;

        executeQueryGetAuth("ai/coaching/" + gameID + "/post?possibleJournal=" + journal, {

        }, this.props.user, (data) => {
            let incomingData = data.body;
            this.setState({
                aiCoachLoading: false,
                aiCoachResults: incomingData,
                hasEvaluated: true
            })

            if (cb) {
                cb();
            }
        });
    }

    renderControls = () => {
        const {
            menuConfig
        } = this.props;

        const hideObjectiveButton = menuConfig.blockObjectives === true;

        return <span style={{ flexGrow: 0, minWidth: '100%' }}>
            <span style={{ display: 'flex', flexDirection: 'row' }}>
                <span style={{ flexGrow: 1 }}>
                    {this.renderJournal()}
                </span>
                <span style={{ width: '400px' }}>
                    {hideObjectiveButton ? undefined : this.renderReflectOnWhatHappenedButton()}
                    {this.getShowClassicScores() ? this.renderScoreControlButton() : <span />}
                    {this.renderReadYourOriginalPlanButton()}
                    {this.props.initialStylesV1 === true ? undefined : this.renderAIButton()}
                    {this.renderResumeButton()}
                </span>
            </span>
        </span>
    }

    renderClassicMode = () => {
        const {
            loadingCharts,
            chartData
        } = this.state;

        const RESULTS_SCREEN_BUTTON_STYLE = { display: 'block', width: '350px', marginTop: '10px', height: '60px', marginLeft: '50px' };

        if (loadingCharts) {
            return <span style={{ display: 'block', width: '100%', height: '100%' }}>
                <span style={{ display: 'block', width: '200px', height: '300px', margin: 'auto', marginTop: '100px' }}>
                    <H4 style={{ textAlign: 'center', marginBottom: '40px' }}>Please Wait...</H4>
                    <Spinner />
                </span>
            </span>
        }

        return <span style={{ display: 'flex', flexDirection: 'column', height: '100%', flexWrap: 'wrap' }}>
            <ReactHighcharts highcharts={Highcharts} options={chartData} />
            <Button onClick={this.handleResumeButtonPress} style={RESULTS_SCREEN_BUTTON_STYLE} large intent={Intent.SUCCESS}>Save Play</Button>
            <div className="clearfix" />
        </span>
    }

    render() {
        const {
            user
        } = this.props;

        if (user.classicMode === 2) {
            return this.renderClassicMode();
        }

        const {
            loadingObjectiveData
        } = this.state;

        if (loadingObjectiveData) {
            return <span style={{ display: 'block', width: '100%', height: '100%' }}>
                <span style={{ display: 'block', width: '200px', height: '300px', margin: 'auto', marginTop: '100px' }}>
                    <H4 style={{ textAlign: 'center', marginBottom: '40px' }}>Please Wait...</H4>
                    <Spinner />
                </span>
            </span>
        }

        // flexDirection: 'column',
        return <span style={{ width: '100%' }}>
            {this.renderAudio()}
            <div style={{ display: 'flex', height: '100%', flexDirection: 'column' }}>
                {this.renderDisplay()}

                {this.renderControls()}
            </div>
            <div className="clearfix" />
        </span>
    }
}
